export type PostTireOrderApiResponse =
  | /** status 200 Standard response */ ({
      orderId?: string | null;
      customerId?: string | null;
      vehicleId?: string | null;
      number?: string | null;
      state?: string | null;
      createdBy?: string | null;
      createdAt?: string | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type PostTireOrderApiArg = {
  body: {
    customerId: string;
    vehicleId?: string;
  };
};
export type GetTireOrderApiResponse =
  | /** status 200 Standard response */ ({
      orderId?: string | null;
      customerId?: string | null;
      vehicleId?: string | null;
      number?: string | null;
      state?: string | null;
      createdBy?: string | null;
      createdAt?: string | null;
      branchId?: string | null;
      authorizationProfileId?: string | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type GetTireOrderApiArg = {
  orderId: string;
};
export type GetTireOptionsApiResponse =
  /** status 200 Standard response */
  | ({
      id?: string | null;
      category?: string | null;
      code?: string | null;
      name?: string | null;
      priority?: number | null;
      isDefault?: boolean | null;
      isActive?: boolean | null;
      dictionary?: string | null;
    } | null)[]
  | /** status 204 Standard response */ undefined;
export type GetTireOptionsApiArg = {
  category: 'TIRTIRESEASON' | 'TIRTIRELOCATION' | 'TIRRIMTYPE' | null;
};
export type GetTireManufacturerApiResponse =
  /** status 200 Standard response */
  | ({
      id?: string | null;
      name?: string | null;
      isDefault?: boolean | null;
      isActive?: boolean | null;
    } | null)[]
  | /** status 204 Standard response */ undefined;
export type GetEmployeeMechanicsByBranchApiResponse =
  | /** status 200 Standard response */ ({
      employees?: ({
        id?: string | null;
        name?: string | null;
        isActive?: boolean | null;
      } | null)[];
    } | null)
  | /** status 204 Standard response */ undefined;
export type GetEmployeeMechanicsByBranchApiArg = {
  /** GUID */
  branchId: string;
};
export type EmployeeMechanicOption = {
  label: string;
  value: string;
  isActive: boolean;
};
export type PostTireSetApiResponse =
  | /** status 200 Standard response */ ({
      setId: string;
    } | null)
  | /** status 204 Standard response */ undefined;
export type PostTireSetApiArg = {
  orderId: string;
  body: {
    assignMechanic?: string | null;
    storedUntil?: string | null;
    note?: string | null;
    categoryId?: string | null;
    isReplacement: boolean;
    contactInformation?: {
      id?: string | null;
      contactId?: string | null;
      name?: string | null;
      identityCard?: string | null;
      phoneNumber?: {
        countryCode?: string | null;
        number?: number | null;
        prefix?: string | null;
      } | null;
      email?: string | null;
    } | null;
    wheels?: ({
      number?: string | null;
      wheelDetails?: {
        manufacturer?: string | null;
        tireWidth?: string | null;
        aspectRatio?: string | null;
        rim?: string | null;
        tread?: number | null;
        rimType?: string | null;
        season?: string | null;
        li?: string | null;
        sr?: string | null;
        dot?: string | null;
        location?: string | null;
        title?: string | null;
        hasHubcap?: boolean | null;
        hasWheelLocks?: boolean | null;
        tireCondition?: string | null;
        note?: string | null;
      } | null;
    } | null)[];
  } | null;
};
export type PostTiresArchiveApiResponse =
  | /** status 200 Standard response */ ({
      printout?: {
        url?: string | null;
        pdfUrl?: string | null;
        fileId?: string | null;
        remoteFileId?: string | null;
      } | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type PostTiresArchiveApiArg = {
  orderId: string;
  setId: string;
  body: {
    assignMechanic?: string;
    wheels: ({
      id: string;
    } | null)[];
  } | null;
};
export type PostTireSetDeliveryNoteApiResponse =
  | /** status 200 Standard response */ ({
      printout?: {
        url?: string | null;
        pdfUrl?: string | null;
        fileId?: string | null;
        remoteFileId?: string | null;
      } | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type PostTireSetDeliveryNoteApiArg = {
  orderId: string;
  setId: string;
  body: {
    wheels: ({
      id: string;
    } | null)[];
  } | null;
};
export type PostTireSetLabelApiResponse =
  | /** status 200 Standard response */ ({
      printout?: {
        url?: string | null;
        pdfUrl?: string | null;
        fileId?: string | null;
        remoteFileId?: string | null;
      } | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type PostTireSetLabelApiArg = {
  orderId: string;
  setId: string;
  body: {
    wheels: ({
      id: string;
    } | null)[];
  } | null;
};
export type PostTireSetsSetReadyApiResponse = /** status 204 Standard response */ undefined;
export type PostTireSetsSetReadyApiArg = {
  body: {
    tireSets: {
      tireOrderId: string;
      tireSetId: string;
    }[];
  };
};
export type PostTireSetsSetUnreadyApiResponse = /** status 204 Standard response */ undefined;
export type PostTireSetsSetUnreadyApiArg = {
  body: {
    tireSets: {
      tireOrderId: string;
      tireSetId: string;
    }[];
  };
};
export type PostTiresTransferToOrderApiResponse = /** status 204 Standard response */ undefined;
export type PostTiresTransferToOrderApiArg = {
  targetOrderId: string;
  body: {
    tireSets: {
      tireOrderId: string;
      tireSetId: string;
    }[];
  };
};
export type PostTireSetsCancelRequestApiResponse = /** status 204 Standard response */ undefined;
export type PostTireSetsCancelRequestApiArg = {
  body: {
    tireSets: {
      orderId: string;
      setId: string;
    }[];
  };
};
export type PostTireSetsSetRequestTransitApiResponse =
  /** status 204 Standard response */ undefined;
export type PostTireSetsSetRequestTransitApiArg = {
  body: {
    tireSets: {
      orderId: string;
      setId: string;
    }[];
  };
};
export type PostTireSetsCancelTransitApiResponse = /** status 204 Standard response */ undefined;
export type PostTireSetsCancelTransitApiArg = {
  body: {
    tireSets: {
      orderId: string;
      setId: string;
    }[];
  };
};
export type GetTireSetApiResponse =
  | /** status 200 Standard response */ ({
      state?: string | null;
      setId: string;
      number?: string | null;
      storedUntil?: string | null;
      note?: string | null;
      categoryId?: string | null;
      isReplacement: boolean;
      contactInformation?: {
        id?: string | null;
        contactId?: string | null;
        name?: string | null;
        identityCard?: string | null;
        phoneNumber?: {
          countryCode?: string | null;
          number?: number | null;
          prefix?: string | null;
        } | null;
        email?: string | null;
      } | null;
      wheels?: ({
        id?: string | null;
        number?: string | null;
        state?: string | null;
        wheelDetails?: {
          manufacturer: string;
          tireWidth?: string | null;
          aspectRatio?: string | null;
          rim?: string | null;
          tread?: number | null;
          rimType?: string | null;
          season?: string | null;
          li?: string | null;
          sr?: string | null;
          dot?: string | null;
          location: string;
          title?: string | null;
          hasHubcap?: boolean | null;
          hasWheelLocks?: boolean | null;
          tireCondition?: string | null;
          note?: string | null;
        } | null;
      } | null)[];
    } | null)
  | /** status 204 Standard response */ undefined;
export type GetTireSetApiArg = {
  orderId: string;
  setId: string;
};
export type PatchTireSetApiResponse = /** status 204 Standard response */ undefined;
export type PatchTireSetApiArg = {
  orderId: string;
  setId: string;
  body: {
    categoryId?: string | null;
    storedUntil?: string | null;
    note?: string | null;
    isReplacement: boolean;
    contactInformation?: {
      id?: string | null;
      contactId?: string | null;
      name?: string | null;
      identityCard?: string | null;
      phoneNumber?: {
        countryCode?: string | null;
        number?: number | null;
        prefix?: string | null;
      } | null;
      email?: string | null;
    } | null;
    wheels?: ({
      id?: string | null;
      number?: string | null;
      state?: string | null;
      wheelDetails?: {
        manufacturer?: string | null;
        tireWidth?: string | null;
        aspectRatio?: string | null;
        rim?: string | null;
        tread?: number | null;
        rimType?: string | null;
        season?: string | null;
        li?: string | null;
        sr?: string | null;
        dot?: string | null;
        location?: string | null;
        title?: string | null;
        hasHubcap?: boolean | null;
        hasWheelLocks?: boolean | null;
        tireCondition?: string | null;
        note?: string | null;
      } | null;
    } | null)[];
  } | null;
};
export type PostTireSetAddWheelsApiResponse =
  | /** status 200 Standard response */ ({
      setId?: string | null;
      printout?: {
        url?: string | null;
        pdfUrl?: string | null;
        fileId?: string | null;
        remoteFileId?: string | null;
      } | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type PostTireSetAddWheelsApiArg = {
  orderId: string;
  setId: string;
  body: {
    assignMechanic?: string | null;
    storedLocation?: string | null;
    storedUntil?: string | null;
    contactPerson?: {
      name?: string | null;
      phoneNumber?: {
        countryCode?: string | null;
        number?: string | null;
        prefix?: string | null;
      } | null;
      email?: string | null;
    } | null;
    wheels?: ({
      number?: string | null;
      wheelDetails?: {
        manufacturer?: string | null;
        tireWidth?: string | null;
        aspectRatio?: string | null;
        rim?: string | null;
        tread?: number | null;
        rimType?: string | null;
        season?: string | null;
        li?: string | null;
        sr?: string | null;
        dot?: string | null;
        location?: string | null;
        title?: string | null;
        hasHubcap: boolean;
        hasWheelLocks: boolean;
        tireCondition?: string | null;
        note?: string | null;
      } | null;
    } | null)[];
  } | null;
};
export type PostTiresReceiptApiResponse =
  | /** status 200 Standard response */ ({
      printout?: {
        url?: string | null;
        pdfUrl?: string | null;
        fileId?: string | null;
        remoteFileId?: string | null;
      } | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type PostTiresReceiptApiArg = {
  orderId: string;
  setId: string;
  body: {
    assignMechanic?: string;
    wheels: ({
      id: string;
    } | null)[];
    receiptDate?: string;
    withoutPrintout: boolean;
  } | null;
};
export type PostTiresIssueApiResponse =
  | /** status 200 Standard response */ ({
      printout?: {
        url?: string | null;
        pdfUrl?: string | null;
        fileId?: string | null;
        remoteFileId?: string | null;
      } | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type PostTiresIssueApiArg = {
  orderId: string;
  setId: string;
  body: {
    assignMechanic?: string;
    wheels: ({
      id: string;
    } | null)[];
  } | null;
};
export type PostTiresRestoreApiResponse =
  | /** status 200 Standard response */ ({
      printout?: {
        url?: string | null;
        pdfUrl?: string | null;
        fileId?: string | null;
        remoteFileId?: string | null;
      } | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type PostTiresRestoreApiArg = {
  orderId: string;
  setId: string;
  body: {
    assignMechanic?: string;
    wheels: ({id: string} | null)[];
  } | null;
};
export type GetTireSetLocationResponse = {
  location: string;
  locationDefinition: {
    contextTarget: 'MANUAL' | 'STORAGE_LOCATION' | 'STORAGE_SECTOR';
    contextId?: string;
  };
  storageLocation: {
    branch: {
      id: string;
      name: string;
    };
    warehouse: {
      id: string;
      name: string;
    };
  };
};
export type GetTireSetLocationArg = {
  orderId: string;
  setId: string;
};
export type UpdateTireSetLocationArg = {
  orderId: string;
  setId: string;
  body: {
    location: string;
    locationDefinition: {
      contextTarget: 'MANUAL' | 'STORAGE_LOCATION' | 'STORAGE_SECTOR';
      contextId?: string;
    };
  };
};
export type UpdateTireSetLocationResponse = void;
export type DeleteTireSetLocationArg = {
  orderId: string;
  setId: string;
};
export type DeleteTireSetLocationResponse = void;
export type GetCodelistTireLocationApiResponse =
  /** status 200 Standard response */
  | ({
      id?: string | null;
      name?: string | null;
      priority?: number | null;
      isActive?: boolean | null;
    } | null)[]
  | /** status 204 Standard response */ undefined;
export type GetTiresGeneralSettingsApiResponse =
  | /** status 200 Standard response */ ({
      documentSettings: {
        receiptNote: {
          docSeriesId: string;
        } | null;
        issueNote: {
          docSeriesId: string;
        } | null;
        archiveNote: {
          docSeriesId: string;
        } | null;
        tireOrder: {
          docSeriesId: string;
        } | null;
        tireSet: {
          docSeriesId: string;
        } | null;
      } | null;
      hasAutomaticStoreUntilSettings: boolean | null;
      storeUntilSettings?: ({
        receivedAt: {
          month: number | null;
          day: number | null;
        } | null;
        receivedTo: {
          month: number | null;
          day: number | null;
        } | null;
        preFillDate: {
          month: number | null;
          day: number | null;
        } | null;
      } | null)[];
    } | null)
  | /** status 204 Standard response */ undefined;
export type GetTiresGeneralSettingsApiArg = void;
export type PutTiresGeneralSettingsApiResponse = /** status 204 Standard response */ undefined;
export type PutTiresGeneralSettingsApiArg = {
  body: {
    documentSettings: {
      receiptNote: {
        docSeriesId: string;
      } | null;
      issueNote: {
        docSeriesId: string;
      } | null;
      archiveNote: {
        docSeriesId: string;
      } | null;
      tireOrder: {
        docSeriesId: string;
      } | null;
      tireSet: {
        docSeriesId: string;
      } | null;
    } | null;
    hasAutomaticStoreUntilSettings: boolean | null;
    storeUntilSettings?: ({
      receivedAt: {
        month: number | null;
        day: number | null;
      } | null;
      receivedTo: {
        month: number | null;
        day: number | null;
      } | null;
      preFillDate: {
        month: number | null;
        day: number | null;
      } | null;
    } | null)[];
  } | null;
};
export type PostTireManufacturerApiResponse =
  | /** status 200 Standard response */ ({
      id?: string | null;
      name?: string | null;
      isDefault?: boolean | null;
      isActive?: boolean | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type PostTireManufacturerApiArg = {
  body: {
    name: string;
    isDefault: boolean;
    isActive: boolean;
  } | null;
};
export type PatchTireManufacturerApiResponse = /** status 204 Standard response */ undefined;
export type PatchTireManufacturerApiArg = {
  /** UUID */
  codelistId: string;
  body: {
    name: string;
    isDefault: boolean;
    isActive: boolean;
  } | null;
};
export type PatchTireManufacturerSetActiveApiResponse =
  /** status 204 Standard response */ undefined;
export type PatchTireManufacturerSetActiveApiArg = {
  /** UUID */
  codelistId: string;
};
export type PatchTireManufacturerSetDefaultApiResponse =
  /** status 204 Standard response */ undefined;
export type PatchTireManufacturerSetDefaultApiArg = {
  /** UUID */
  codelistId: string;
};
export type PatchTireManufacturerSetInactiveApiResponse =
  /** status 204 Standard response */ undefined;
export type PatchTireManufacturerSetInactiveApiArg = {
  /** UUID */
  codelistId: string;
};
export type PatchTireManufacturerUnsetDefaultApiResponse =
  /** status 204 Standard response */ undefined;
export type PatchTireManufacturerUnsetDefaultApiArg = {
  /** UUID */
  codelistId: string;
};
export type PostTireLocationApiResponse =
  | /** status 200 Standard response */ ({
      id?: string | null;
      name?: string | null;
      priority?: number | null;
      isActive?: boolean | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type PostTireLocationApiArg = {
  body: {
    name: string;
    isActive: boolean;
  } | null;
};
export type PatchTireLocationApiResponse = /** status 204 Standard response */ undefined;
export type PatchTireLocationApiArg = {
  /** UUID */
  codelistId: string;
  body: {
    name: string;
    isActive: boolean;
  } | null;
};
export type PatchTireLocationPositionDownApiResponse =
  /** status 204 Standard response */ undefined;
export type PatchTireLocationPositionDownApiArg = {
  /** UUID */
  codelistId: string;
};
export type PatchTireLocationPositionUpApiResponse = /** status 204 Standard response */ undefined;
export type PatchTireLocationPositionUpApiArg = {
  /** UUID */
  codelistId: string;
};
export type PatchTireLocationSetActiveApiResponse = /** status 204 Standard response */ undefined;
export type PatchTireLocationSetActiveApiArg = {
  /** UUID */
  codelistId: string;
};
export type PatchTireLocationSetInactiveApiResponse = /** status 204 Standard response */ undefined;
export type PatchTireLocationSetInactiveApiArg = {
  /** UUID */
  codelistId: string;
};
export type GetTireVehicleCountApiResponse =
  | /** status 200 Standard response */ ({
      count?: number | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type GetTireVehicleCountApiArg = {
  customerId?: string;
  vehicleId?: string;
};
export type GetTireSetCountApiResponse =
  | /** status 200 Standard response */ ({
      count?: number | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type GetTireSetCountApiArg = {
  customerId?: string;
  vehicleId?: string;
  states?: (('INSTOCK' | 'PICKED' | 'NEW') | null)[];
};
export type GetOrderSetDefaultContactPersonApiResponse =
  | /** status 200 Standard response */ ({
      contactInformation?: {
        id?: string | null;
        contactId?: string | null;
        identityCard?: string | null;
        name?: string | null;
        phoneNumber?: {
          countryCode?: string | null;
          number?: string | null;
          prefix?: string | null;
        } | null;
        email?: string | null;
      } | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type GetOrderSetDefaultContactPersonApiArg = {
  orderId: string;
};
export type GetTireIdsOrdersApiApiArg = {
  customerId?: string;
  vehicleId?: string;
};
export type GetTireIdsOrdersApiApiResponse =
  /** status 200 Standard response */
  | ({
      orderId?: string | null;
      customerId?: string | null;
      vehicleId?: string | null;
      number?: string | null;
      state?: string | null;
      createdBy?: string | null;
      createdAt?: string | null;
    } | null)[]
  | /** status 204 Standard response */ undefined;

export type GetTireWarehousesApiResponse =
  /** status 200 Standard response */
  {
    warehouseId: string;
    name: string;
  }[];
export type GetTireWarehousesApiArg = {
  branchId?: string;
} | void;
export type PostTireWarehouseApiResponse =
  | /** status 200 Standard response */ ({
      warehouseId: string;
    } | null)
  | /** status 204 Standard response */ void;
export type PostTireWarehouseApiArg = {
  body: {
    name: string;
    branchId: string;
    storageLocationSeparator?: string | null;
  } | null;
};
export type PostWarehouseEnablingSetAsAllowApiResponse = /** status 204 Standard response */ void;
export type PostWarehouseEnablingSetAsAllowApiArg = void;
export type PostWarehouseEnablingSetAsDisallowApiResponse =
  /** status 204 Standard response */ void;
export type PostWarehouseEnablingSetAsDisallowApiArg = void;
export type GetTireWarehouseApiResponse =
  | /** status 200 Standard response */ ({
      warehouseId: string;
      name: string;
      branchId: string;
      storageLocationSeparator?: string | null;
    } | null)
  | /** status 204 Standard response */ void;
export type GetTireWarehouseApiArg = {
  warehouseId: string;
};
export type DeleteTireWarehouseApiResponse = /** status 204 Standard response */ void;
export type DeleteTireWarehouseApiArg = {
  warehouseId: string;
};
export type PatchTireWarehouseApiResponse = /** status 204 Standard response */ void;
export type PatchTireWarehouseApiArg = {
  warehouseId: string;
  body: {
    name: string;
    branchId: string;
    storageLocationSeparator?: string | null;
  } | null;
};
export type GetTireWarehouseSettingsApiResponse = {
  isWarehouseAllowed: boolean;
};
export type GetTireWarehouseSettingsApiArg = void;

export type GetDefaultStoreUntilByOrderIdApiResponse = {defaultStoreUntil?: string | null};

export type GetDefaultStoreUntilByOrderIdApiArg = {orderId: string};

export type PostGeneralSettingApiResponse =
  | /** status 200 Standard response */ ({
      generalSettingId: string;
    } | null)
  | /** status 204 Standard response */ void;
export type PostGeneralSettingApiArg = {
  body: {
    name: string;
    branchIds: string[];
    documentSettings: {
      receiptNote: {
        docSeriesId: string;
      } | null;
      issueNote: {
        docSeriesId: string;
      } | null;
      archiveNote: {
        docSeriesId: string;
      } | null;
      tireOrder: {
        docSeriesId: string;
      } | null;
      tireSet: {
        docSeriesId: string;
      } | null;
    } | null;
    hasAutomaticStoreUntilSettings: boolean;
    storeUntilSettings?: ({
      receivedAt: {
        month: number;
        day: number;
      } | null;
      receivedTo: {
        month: number;
        day: number;
      } | null;
      preFillDate: {
        month: number;
        day: number;
      } | null;
    } | null)[];
  } | null;
};
export type GetGeneralSettingApiResponse =
  | /** status 200 Standard response */ ({
      generalSettingId: string;
      name: string;
      branchIds: string[];
      documentSettings: {
        receiptNote: {
          docSeriesId: string;
        } | null;
        issueNote: {
          docSeriesId: string;
        } | null;
        archiveNote: {
          docSeriesId: string;
        } | null;
        tireOrder: {
          docSeriesId: string;
        } | null;
        tireSet: {
          docSeriesId: string;
        } | null;
      } | null;
      hasAutomaticStoreUntilSettings: boolean;
      storeUntilSettings?: ({
        receivedAt: {
          month: number;
          day: number;
        } | null;
        receivedTo: {
          month: number;
          day: number;
        } | null;
        preFillDate: {
          month: number;
          day: number;
        } | null;
      } | null)[];
    } | null)
  | /** status 204 Standard response */ void;
export type GetGeneralSettingApiArg = {
  generalSettingId: string;
};
export type DeleteGeneralSettingApiResponse = /** status 204 Standard response */ void;
export type DeleteGeneralSettingApiArg = {
  generalSettingId: string;
};
export type PatchGeneralSettingApiResponse = /** status 204 Standard response */ void;
export type PatchGeneralSettingApiArg = {
  generalSettingId: string;
  body: {
    name: string;
    branchIds: string[];
    documentSettings: {
      receiptNote: {
        docSeriesId: string;
      } | null;
      issueNote: {
        docSeriesId: string;
      } | null;
      archiveNote: {
        docSeriesId: string;
      } | null;
      tireOrder: {
        docSeriesId: string;
      } | null;
      tireSet: {
        docSeriesId: string;
      } | null;
    } | null;
    hasAutomaticStoreUntilSettings: boolean;
    storeUntilSettings?: ({
      receivedAt: {
        month: number;
        day: number;
      } | null;
      receivedTo: {
        month: number;
        day: number;
      } | null;
      preFillDate: {
        month: number;
        day: number;
      } | null;
    } | null)[];
  } | null;
};
export type PostTireSetRequestApiResponse = /** status 204 Standard response */ void;
export type PostTireSetRequestApiArg = {
  orderId: string;
  setId: string;
  body: {
    destinationBranchId: string;
    neededAt: string;
    note?: string | null;
  };
};
export type PatchTireSetRequestApiResponse = /** status 204 Standard response */ void;
export type PatchTireSetRequestApiArg = {
  orderId: string;
  setId: string;
  body: {
    destinationBranchId: string;
    neededAt: string;
    note?: string | null;
  };
};
export type GetTireSetRequestApiResponse = {
  destinationBranchId: string;
  homeBranchId: string;
  neededAt: string;
  note?: string;
  tireSetRequestId: string;
  state: 'REQUESTED' | 'PREPARED' | 'DISPATCHED' | 'CANCELLED';
};
export type GetTireSetRequestApiArg = {
  orderId: string;
  setId: string;
};
export type GetTireSetDestinationBranchApiResponse = {
  branchId: string;
  branchName: string;
  transitTimeDays: number;
  isDefault: boolean;
}[];
export type GetTireSetDestinationBranchApiArg = {
  orderId: string;
  setId: string;
};
export type GetTireOrderDestinationBranchApiResponse = {
  branchId: string;
  branchName: string;
  transitTimeDays: number;
  isDefault: boolean;
}[];
export type GetTireOrderDestinationBranchApiArg = {
  orderId: string;
};
export type PostTireSetCancelRequestApiResponse = /** status 204 Standard response */ void;
export type PostTireSetCancelRequestApiArg = {
  orderId: string;
  setId: string;
};
export type GetTireSetActionsApiResponse =
  | /** status 200 Standard response */ {
      orderSetActions: {
        options: {
          type: string;
          key: string;
          style: string;
          position: number;
        }[];
      };
    }
  | /** status 204 Standard response */ void;
export type GetTireSetActionsApiArg = {
  orderId: string;
  setId: string;
};
export type GetTireAspectRatiosApiResponse =
  /** status 200 Standard response */
  | {
      tireAspectRatioId: string;
      name: string;
      isActive: boolean;
    }[]
  | /** status 204 Standard response */ void;
export type GetTireAspectRatiosApiArg = void;
export type PostTireAspectRatioApiResponse =
  | /** status 200 Standard response */ {
      tireAspectRatioId: string;
    }
  | /** status 204 Standard response */ void;
export type PostTireAspectRatioApiArg = {
  body: {
    name: string;
  };
};
export type GetTireAspectRatioApiResponse =
  | /** status 200 Standard response */ {
      tireAspectRatioId: string;
      name: string;
      isActive: boolean;
    }
  | /** status 204 Standard response */ void;
export type GetTireAspectRatioApiArg = {
  tireAspectRatioId: string;
};
export type DeleteTireAspectRatioApiResponse = /** status 204 Standard response */ void;
export type DeleteTireAspectRatioApiArg = {
  tireAspectRatioId: string;
};
export type PatchTireAspectRatioApiResponse = /** status 204 Standard response */ void;
export type PatchTireAspectRatioApiArg = {
  tireAspectRatioId: string;
  body: {
    name: string;
  };
};
export type PostTireAspectRatioSetActiveApiResponse = /** status 204 Standard response */ void;
export type PostTireAspectRatioSetActiveApiArg = {
  tireAspectRatioId: string;
};
export type PostTireAspectRatioSetInactiveApiResponse = /** status 204 Standard response */ void;
export type PostTireAspectRatioSetInactiveApiArg = {
  tireAspectRatioId: string;
};
export type GetTireCategoriesApiResponse =
  /** status 200 Standard response */
  | {
      tireCategoryId: string;
      name: string;
      isActive: boolean;
      isDefault: boolean;
      branchIds?: string[] | null;
    }[]
  | /** status 204 Standard response */ void;
export type GetTireCategoriesApiArg = {
  branchId?: string | null;
};
export type PostTireCategoryApiResponse =
  | /** status 200 Standard response */ {
      tireCategoryId: string;
    }
  | /** status 204 Standard response */ void;
export type PostTireCategoryApiArg = {
  body: {
    name: string;
    branchIds?: string[] | null;
  };
};
export type GetTireCategoryApiResponse =
  | /** status 200 Standard response */ {
      tireCategoryId: string;
      branchIds?: string[] | null;
      name: string;
      isActive: boolean;
      isDefault: boolean;
    }
  | /** status 204 Standard response */ void;
export type GetTireCategoryApiArg = {
  tireCategoryId: string;
};
export type DeleteTireCategoryApiResponse = /** status 204 Standard response */ void;
export type DeleteTireCategoryApiArg = {
  tireCategoryId: string;
};
export type PatchTireCategoryApiResponse = /** status 204 Standard response */ void;
export type PatchTireCategoryApiArg = {
  tireCategoryId: string;
  body: {
    name: string;
    branchIds?: string[] | null;
  };
};
export type PostTireCategorySetActiveApiResponse = /** status 204 Standard response */ void;
export type PostTireCategorySetActiveApiArg = {
  tireCategoryId: string;
};
export type PostTireCategorySetDefaultApiResponse = /** status 204 Standard response */ void;
export type PostTireCategorySetDefaultApiArg = {
  tireCategoryId: string;
};
export type PostTireCategoryUnsetDefaultApiResponse = /** status 204 Standard response */ void;
export type PostTireCategoryUnsetDefaultApiArg = {
  tireCategoryId: string;
};
export type PostTireCategorySetInactiveApiResponse = /** status 204 Standard response */ void;
export type PostTireCategorySetInactiveApiArg = {
  tireCategoryId: string;
};
export type GetTireLoadIndexesApiResponse =
  /** status 200 Standard response */
  | {
      tireLoadIndexId: string;
      name: string;
      isActive: boolean;
    }[]
  | /** status 204 Standard response */ void;
export type GetTireLoadIndexesApiArg = void;
export type PostTireLoadIndexApiResponse =
  | /** status 200 Standard response */ {
      tireLoadIndexId: string;
    }
  | /** status 204 Standard response */ void;
export type PostTireLoadIndexApiArg = {
  body: {
    name: string;
  };
};
export type GetTireLoadIndexApiResponse =
  | /** status 200 Standard response */ {
      tireLoadIndexId: string;
      name: string;
      isActive: boolean;
    }
  | /** status 204 Standard response */ void;
export type GetTireLoadIndexApiArg = {
  tireLoadIndexId: string;
};
export type DeleteTireLoadIndexApiResponse = /** status 204 Standard response */ void;
export type DeleteTireLoadIndexApiArg = {
  tireLoadIndexId: string;
};
export type PatchTireLoadIndexApiResponse = /** status 204 Standard response */ void;
export type PatchTireLoadIndexApiArg = {
  tireLoadIndexId: string;
  body: {
    name: string;
  };
};
export type PostTireLoadIndexSetActiveApiResponse = /** status 204 Standard response */ void;
export type PostTireLoadIndexSetActiveApiArg = {
  tireLoadIndexId: string;
};
export type PostTireLoadIndexSetInactiveApiResponse = /** status 204 Standard response */ void;
export type PostTireLoadIndexSetInactiveApiArg = {
  tireLoadIndexId: string;
};
export type GetTireRimsApiResponse =
  /** status 200 Standard response */
  | {
      tireRimId: string;
      name: string;
      isActive: boolean;
    }[]
  | /** status 204 Standard response */ void;
export type GetTireRimsApiArg = void;
export type PostTireRimApiResponse =
  | /** status 200 Standard response */ {
      tireRimId: string;
    }
  | /** status 204 Standard response */ void;
export type PostTireRimApiArg = {
  body: {
    name: string;
  };
};
export type GetTireRimApiResponse =
  | /** status 200 Standard response */ {
      tireRimId: string;
      name: string;
      isActive: boolean;
    }
  | /** status 204 Standard response */ void;
export type GetTireRimApiArg = {
  tireRimId: string;
};
export type DeleteTireRimApiResponse = /** status 204 Standard response */ void;
export type DeleteTireRimApiArg = {
  tireRimId: string;
};
export type PatchTireRimApiResponse = /** status 204 Standard response */ void;
export type PatchTireRimApiArg = {
  tireRimId: string;
  body: {
    name: string;
  };
};
export type PostTireRimSetActiveApiResponse = /** status 204 Standard response */ void;
export type PostTireRimSetActiveApiArg = {
  tireRimId: string;
};
export type PostTireRimSetInactiveApiResponse = /** status 204 Standard response */ void;
export type PostTireRimSetInactiveApiArg = {
  tireRimId: string;
};
export type GetTireSpeedRatiosApiResponse =
  /** status 200 Standard response */
  | {
      tireSpeedRatioId: string;
      name: string;
      isActive: boolean;
    }[]
  | /** status 204 Standard response */ void;
export type GetTireSpeedRatiosApiArg = void;
export type PostTireSpeedRatioApiResponse =
  | /** status 200 Standard response */ {
      tireSpeedRatioId: string;
    }
  | /** status 204 Standard response */ void;
export type PostTireSpeedRatioApiArg = {
  body: {
    name: string;
  };
};
export type GetTireSpeedRatioApiResponse =
  | /** status 200 Standard response */ {
      tireSpeedRatioId: string;
      name: string;
      isActive: boolean;
    }
  | /** status 204 Standard response */ void;
export type GetTireSpeedRatioApiArg = {
  tireSpeedRatioId: string;
};
export type PatchTireSpeedRatioApiResponse = /** status 204 Standard response */ void;
export type PatchTireSpeedRatioApiArg = {
  tireSpeedRatioId: string;
  body: {
    name: string;
  };
};
export type DeleteTireSpeedRatioApiResponse = /** status 204 Standard response */ void;
export type DeleteTireSpeedRatioApiArg = {
  tireSpeedRatioId: string;
};
export type PostTireSpeedRatioSetActiveApiResponse = /** status 204 Standard response */ void;
export type PostTireSpeedRatioSetActiveApiArg = {
  tireSpeedRatioId: string;
};
export type PostTireSpeedRatioSetInactiveApiResponse = /** status 204 Standard response */ void;
export type PostTireSpeedRatioSetInactiveApiArg = {
  tireSpeedRatioId: string;
};
export type GetTireWidthsApiResponse =
  /** status 200 Standard response */
  | {
      /** UUID */
      tireWidthId: string;
      name: string;
      isActive: boolean;
    }[]
  | /** status 204 Standard response */ void;
export type GetTireWidthsApiArg = void;
export type PostTireWidthApiResponse =
  | /** status 200 Standard response */ {
      /** UUID */
      tireWidthId: string;
    }
  | /** status 204 Standard response */ void;
export type PostTireWidthApiArg = {
  body: {
    name: string;
  };
};
export type GetTireWidthApiResponse =
  | /** status 200 Standard response */ {
      /** UUID */
      tireWidthId: string;
      name: string;
      isActive: boolean;
    }
  | /** status 204 Standard response */ void;
export type GetTireWidthApiArg = {
  tireWidthId: string;
};
export type DeleteTireWidthApiResponse = /** status 204 Standard response */ void;
export type DeleteTireWidthApiArg = {
  /** UUID */
  tireWidthId: string;
};
export type PatchTireWidthApiResponse = /** status 204 Standard response */ void;
export type PatchTireWidthApiArg = {
  tireWidthId: string;
  body: {
    name: string;
  };
};
export type PostTireWidthSetActiveApiResponse = /** status 204 Standard response */ void;
export type PostTireWidthSetActiveApiArg = {
  tireWidthId: string;
};
export type PostTireWidthSetInactiveApiResponse = /** status 204 Standard response */ void;
export type PostTireWidthSetInactiveApiArg = {
  tireWidthId: string;
};
export type TireSetReceiptResponse =
  | /** status 200 Standard response */ ({
      printout?: {
        url?: string | null;
        pdfUrl?: string | null;
        fileId?: string | null;
        remoteFileId?: string | null;
      } | null;
    } | null)
  | /** status 204 Standard response */ undefined;

export type TireSetReceiptApiArg = {
  orderId: string;
  setId: string;
  body: {
    assignMechanic?: string;
    wheels: {
      id: string;
    }[];
  };
};

export type TireOrderArchiveResponse = /** status 204 Standard response */ void;
export type TireOrderArchiveApiArg = {
  orderId: string;
};

export type TireOrderRestoreResponse = /** status 204 Standard response */ void;
export type TireOrderRestoreApiArg = {
  orderId: string;
};

export type TireOrderDeleteResponse = /** status 204 Standard response */ void;
export type TireOrderDeleteApiArg = {
  orderId: string;
};

export type GetTireOrderActionsApiResponse =
  | /** status 200 Standard response */ {
      orderActions: {
        options: {
          type: string;
          key: string;
          style: string;
          position: number;
        }[];
      };
    }
  | /** status 204 Standard response */ void;
export type GetTireOrderActionsApiArg = {
  orderId: string;
};

export type PutTireOrderAuthorizationProfileResponse = /** status 204 Standard response */ void;
export type PutTireOrderAuthorizationProfileApiArg = {
  orderId: string;
  authorizationProfileId: string;
};

export type TireSetsSetRequestTransitResponse =
  | /** status 200 Standard response */ (
      | {
          printout?: {
            url?: string | null;
            pdfUrl?: string | null;
            fileId?: string | null;
            remoteFileId?: string | null;
          } | null;
          transportDocumentId: string;
        }[]
      | null
    )
  | /** status 204 Standard response */ undefined;
export type TireSetsSetRequestTransitApiArg = {
  body: {
    tireSets: {
      orderId: string;
      setId: string;
    }[];
  };
};
export type TireSetsSetTransitAcceptanceResponse = /** status 204 Standard response */ void;
export type TireSetsSetTransitAcceptanceApiArg = {
  body: {
    tireSets: {
      orderId: string;
      setId: string;
    }[];
  };
};
export type TireSetsSetCancelTransitResponse = /** status 204 Standard response */ void;
export type TireSetsSetCancelTransitApiArg = {
  body: {
    tireSets: {
      orderId: string;
      setId: string;
    }[];
  };
};
export type PostTiresIssueBulkResponse =
  | /** status 200 Standard response */ {
      printout: {
        url: 'url';
        pdfUrl: 'pdfUrl';
        fileId: 'fileId';
        remoteFileId: 'remoteFileId';
      };
    }[]
  | /** status 204 Standard response */ undefined;

export type PostTiresIssueBulkApiArg = {
  body: {
    tireSets: {
      orderId: string;
      setId: string;
    }[];
    assignMechanic?: string;
  };
};

export type PostTireSetActionsApiResponse = {
  options: {
    type: 'list-item' | 'divider';
    key:
      | 'transferToOrder'
      | 'printLabel'
      | 'printDeliveryNote'
      | 'receipt'
      | 'issue'
      | 'archive'
      | 'restore'
      | 'delete'
      | 'request'
      | 'modifyRequest'
      | 'transitRequest'
      | 'acceptanceTransitRequest'
      | 'prepareRequest'
      | 'unprepareRequest'
      | 'cancelTransitRequest'
      | 'cancelRequest';
    style: 'hidden' | 'disabled' | 'enable';
    position: number;
  }[];
};

export type PostTireSetActionsApiArg = {
  orderId: string;
  setId: string;
  body: {
    wheelIds: string[];
  };
};

export type PostTireTransitApiResponse =
  | /** status 200 Standard response */ ({
      transitSettingId?: string | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type PostTireTransitApiArg = {
  body: {
    homeBranchId: string;
    destinationBranch: {
      branchId: string;
      docSeriesId: string;
      transitTimeDays: number;
      isDefault: boolean;
    }[];
  };
};

export type GetTireTransitApiResponse =
  | /** status 200 Standard response */ ({
      transitSettingId?: string | null;
      homeBranchId?: string | null;
      destinationBranch?:
        | ({
            branchId?: string | null;
            docSeriesId?: string | null;
            transitTimeDays?: number | null;
            isDefault?: boolean | null;
          } | null)[]
        | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type GetTireTransitApiArg = {
  transitSettingId: string;
};

export type PatchTireTransitApiResponse =
  | /** status 200 Standard response */ ({
      transitSettingId?: string | null;
    } | null)
  | /** status 204 Standard response */ undefined;
export type PatchTireTransitApiArg = {
  transitSettingId: string;
  body: {
    homeBranchId: string;
    destinationBranch: {
      branchId: string;
      docSeriesId: string;
      transitTimeDays: number;
      isDefault: boolean;
    }[];
  };
};

export type DeleteTireTransitApiResponse =
  | /** status 200 Standard response */ undefined
  | /** status 204 Standard response */ undefined;
export type DeleteTireTransitApiArg = {
  transitSettingId: string;
};

export type PostTireSetsSetReplacementApiResponse = /** status 204 Standard response */ void;
export type PostTireSetsSetReplacementApiArg = {
  body: {
    tireSets: {
      orderId: string;
      setId: string;
    }[];
  };
};

export type PostTireSetsUnsetReplacementApiResponse = /** status 204 Standard response */ void;
export type PostTireSetsUnsetReplacementApiArg = {
  body: {
    tireSets: {
      orderId: string;
      setId: string;
    }[];
  };
};
export type GetTireConditionsApiResponse =
  /** status 200 Standard response */
  | ({
      tireConditionId: string;
      name: string;
      isActive: boolean;
      isDefault: boolean;
    } | null)[]
  | /** status 204 Standard response */ void;
export type PostTireConditionApiResponse =
  | /** status 200 Standard response */ {
      tireConditionId: string;
    }
  | /** status 204 Standard response */ void;
export type PostTireConditionApiArg = {
  body: {
    name: string;
  };
};
export type GetTireConditionApiResponse =
  | /** status 200 Standard response */ {
      tireConditionId: string;
      name: string;
      isActive: boolean;
      isDefault: boolean;
    }
  | /** status 204 Standard response */ void;
export type GetTireConditionApiArg = {
  tireConditionId: string;
};
export type DeleteTireConditionApiResponse = /** status 204 Standard response */ void;
export type DeleteTireConditionApiArg = {
  tireConditionId: string;
};
export type PatchTireConditionApiResponse = /** status 204 Standard response */ void;
export type PatchTireConditionApiArg = {
  tireConditionId: string;
  body: {
    name: string;
  };
};
export type PostTireConditionSetActiveApiResponse = /** status 204 Standard response */ void;
export type PostTireConditionSetActiveApiArg = {
  tireConditionId: string;
};
export type PostTireConditionSetInactiveApiResponse = /** status 204 Standard response */ void;
export type PostTireConditionSetInactiveApiArg = {
  tireConditionId: string;
};
export type PostTireConditionSetDefaultApiResponse = /** status 204 Standard response */ void;
export type PostTireConditionSetDefaultApiArg = {
  tireConditionId: string;
};
export type PostTireConditionUnsetDefaultApiResponse = /** status 204 Standard response */ void;
export type PostTireConditionUnsetDefaultApiArg = {
  tireConditionId: string;
};
